import React, { useEffect, useState } from "react";

const EstimatedCB = () => {

    const cMonth = {
        1: "January", 2: "February", 3: "March", 4: "April", 5: "May", 6: "June",
        7: "July", 8: "August", 9: "September", 10: "October", 11: "November", 12: "December"
    };

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth() + 1;

    const years = [currentYear - 1, currentYear, currentYear + 1];

    const [input, setInput] = useState({
        month: currentMonth,
        year: currentYear,
        comm: '0'
    });

    const [commodityDropDown, setCommodityDropDown] = useState([]);

    // LOAD COMMODITIES
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_URL}/api/cb/comm`);
                const data = await response.json();
                console.log("API RESPONSE:", data);
                setCommodityDropDown(data.comm || []);
            } catch (error) {
                console.error("Error loading commodities:", error);
            }
        };

        fetchData();
    }, []);

    // HANDLE INPUT CHANGE
    const handleChange = (e) => {
        const { name, value } = e.target;
        setInput(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // DOWNLOAD EXCEL
    const downloadExcel = async () => {

        try {
            const url = `${process.env.REACT_APP_URL}/api/cb/estimated-cb/excel?month=${input.month}&year=${input.year}&commId=${input.comm}`;

            console.log("Downloading from:", url);

            const response = await fetch(url);

            if (!response.ok) {
                throw new Error("Download failed");
            }

            const blob = await response.blob();

            // Create download link
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);

            // File name (dynamic)
            const fileName = `Estimated_CB_${input.month}_${input.year}.xlsx`;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();


            link.remove();
            window.URL.revokeObjectURL(link.href);

        } catch (error) {
            console.error("Error downloading file:", error);
            alert("Failed to download Excel");
        }
    };

    return (
        <div align="center">

            <br />

            <table border="1">

                <tbody>

                    <tr className="tableheader">
                        <td colSpan={4} align="center">
                            Estimated CB Excel Download
                        </td>
                    </tr>

                    <tr className="tableheader">

                        <td>
                            Month
                            <br />
                            <select name="month" value={input.month} onChange={handleChange}>
                                {Object.entries(cMonth).map(([key, value]) => (
                                    <option key={key} value={key}>{value}</option>
                                ))}
                            </select>
                        </td>

                        <td>
                            Year
                            <br />
                            <select name="year" value={input.year} onChange={handleChange}>
                                {years.map((year) => (
                                    <option key={year} value={year}>{year}</option>
                                ))}
                            </select>
                        </td>

                        <td>
                            Commodity
                            <br />
                            <select name="comm" value={input.comm} onChange={handleChange}>
                                <option value="0">All </option>
                                {commodityDropDown.map(item => (
                                    <option key={item.comm_id} value={item.comm_id}>
                                        {item.comm_name_en}
                                    </option>
                                ))}
                            </select>
                        </td>

                        <td>
                            <br />
                            <input
                                type="button"
                                value="Download Excel"
                                className="button"
                                onClick={downloadExcel}
                            />
                        </td>

                    </tr>

                </tbody>

            </table>

        </div>
    );
};

export default EstimatedCB;